<template>
  <div class="cy-plugin-widget-table">
    <CyEmptyData
      v-if="hasError"
      :title="$t('plugins.widgetUnavailableTitle')"
      :text="$t('plugins.widgetUnavailableText')"/>
    <CyTable
      v-else
      :headers="headers"
      :items="rows"/>
  </div>
</template>

<script>
import CyEmptyData from '@/components/CyEmptyData.vue'
import CyTable from '@/components/CyTable.vue'
import REGEX from '@/utils/config/regex'

export default {
  name: 'CyPluginWidgetTable',
  components: { CyEmptyData, CyTable },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    queryData: {
      type: [Array, Object],
      default: null,
    },
  },
  computed: {
    hasError () {
      return _.isNil(this.queryData)
    },
    headers () {
      return this.columns.map(({ value, title, type }) => ({
        key: value,
        value,
        title,
        type: this.resolveColumnType(value, type),
      }))
    },
    rows () {
      const data = this.queryData
      if (_.isNil(data)) return []
      // Wrapper object: { data: [...rows] }
      if (_.isPlainObject(data)) return _.isArray(data.data) ? data.data : []
      if (!_.isArray(data)) return []
      // Array of result-sets: [{ data: [...rows] }, ...] -> flatten inner rows.
      // Heuristic: treat the array as result-sets only when every entry is a
      // { data: [...] } wrapper; otherwise it is a bare array of row objects.
      const isResultSets = data.length > 0
        && data.every((entry) => _.isPlainObject(entry) && _.isArray(entry.data))
      if (isResultSets) return data.flatMap((entry) => entry.data)
      // Bare array of row objects.
      return data
    },
  },
  methods: {
    resolveColumnType (key, type) {
      if (type && type !== 'string') return type
      const values = this.rows
        .map((row) => _.get(row, key))
        .filter((value) => !_.isNil(value) && value !== '')
      if (_.isEmpty(values)) return type
      const isAllUrls = values.every((value) => _.isString(value) && REGEX.URL_SCHEME.test(value))
      return isAllUrls ? 'link' : type
    },
  },
}
</script>

<style lang="scss" scoped>
.cy-plugin-widget-table {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  min-height: 0;
}
</style>
